module.exports = __webpack_public_path__ + "img/Frame 1903.095c4677.png";